import React from 'react'

const Contact = () => {
  return (
    <div className={'contact'}>
      <span>Ing.arch. Michal Šoun<br />+420 604 273 856<br /><a href="mailto:michal.soun@gmail.com">michal.soun@gmail.com</a></span>
    </div>
  )
}

export default Contact